import { render, staticRenderFns } from "./MobilePagination.vue?vue&type=template&id=dde19b56&scoped=true&"
import script from "./MobilePagination.vue?vue&type=script&lang=js&"
export * from "./MobilePagination.vue?vue&type=script&lang=js&"
import style0 from "./MobilePagination.vue?vue&type=style&index=0&id=dde19b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde19b56",
  null
  
)

export default component.exports